require('file-loader?name=[name].[ext]!./BonnerCountyLogo-favicon.png');
require('file-loader?name=[name].[ext]!./BonnerCountyLogo-45.png');
require('file-loader?name=[name].[ext]!./BonnerCountyLogo-75.png');
require("file-loader?name=[name].[ext]!./ExportRoadList.html");
require('file-loader?name=[name].[ext]!./index.css');
import './index.css';
import * as query from "@arcgis/core/rest/query";

const mainBodyDiv = document.getElementById("mainBodyDiv");

window.addEventListener('keydown', function (event) {
    // Check for 'P' (key code 80) and either Ctrl (Windows/Linux) or Meta (Mac)
    if ((event.ctrlKey || event.metaKey) && (event.key === 'p' || event.key === 'P')) {
        event.preventDefault();
        console.log("Print shortcut (Ctrl+P) blocked.");
    }
});

LoadPage();

function arrayIntoChunks(array, chunkSize) {
    //// If using display:grid in css, changes to chunkSize must also be done in the css for any nth-child styling
    //// I opted for using a table and bypassing this problem.
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        const chunk = array.slice(i, i + chunkSize);
        result.push(chunk);
    }
    return result;
}

async function LoadPage() {
    const fetchHtml = await fetch("BodyHTML.html", { cache: "reload" });
    const htmlResponse = await fetchHtml.text();
    mainBodyDiv.innerHTML = htmlResponse;

    const queryResults = await query.executeQueryJSON("https://cloudgis.bonnercountyid.gov/server/rest/services/Hosted/Road_List_Table/FeatureServer/0", {
        where: "objectid > 0",
        outFields: ["st_full", "created_date"]
    });
    // console.log(queryResults);

    const queryResultFeatures = queryResults.features;

    //// Set last udpate html
    const date = new Date(queryResultFeatures[0].attributes.created_date);
    // console.log(date.toLocaleString());
    const dateFormat = date.toLocaleString().split(",")[0]; //// https://www.w3schools.com/jsref/jsref_tolocalestring.asp
    const dateFormatDivHtml = `Last update: ${dateFormat}`;
    document.getElementById("last-updated-div").innerHTML = `${dateFormatDivHtml}`;

    //// Create an array of unique road names, https://stackoverflow.com/questions/15125920/how-to-get-distinct-values-from-an-array-of-objects-in-javascript/35092559#35092559
    const uniqueNamesArray = [...new Set(queryResultFeatures.map(item => item.attributes.st_full))];
    // uniqueNamesArray.push("MEH");
    // uniqueNamesArray.push("MEH");
    // uniqueNamesArray.push("MEH");

    const mainContentInner = document.getElementById("mainContent-inner");

    setResponsive(uniqueNamesArray, mainContentInner);

    //// Recreate the table based on window size, https://stackoverflow.com/questions/5489946/how-to-wait-for-the-end-of-resize-event-and-only-then-perform-an-action/5490021#5490021
    let resize = null;
    window.onresize = function (event) {
        clearTimeout(resize);
        resize = setTimeout(() => {
            setResponsive(uniqueNamesArray, mainContentInner);
        }, 200);
    };

    document.getElementById("btn-export").addEventListener("click", (e) => {
        console.log(e);
        sessionStorage.setItem("uniqueNamesArray", JSON.stringify(uniqueNamesArray));
        sessionStorage.setItem("lastUpdateHtml", JSON.stringify(dateFormatDivHtml));
        window.open("ExportRoadList.html");
    });

}

function setResponsive(namesArray, domElem) { //// Create table based on window size
    if (window.innerWidth < 700) {
        CreateTableTemplate(namesArray, 2, domElem);
    } else if (window.innerWidth < 1000) {
        CreateTableTemplate(namesArray, 3, domElem);
    } else if (window.innerWidth < 1200) {
        CreateTableTemplate(namesArray, 4, domElem);
    } else {
        CreateTableTemplate(namesArray, 6, domElem);
    }
}

function CreateTableTemplate(namesArray, number_of_groups, domElem) {
    domElem.innerHTML = "";

    //// Group into sets in order to write the table
    const groupedArray = arrayIntoChunks(namesArray, number_of_groups);
    // console.log(groupedArray);

    const table = document.createElement("table");
    table.className = "resultTable";
    groupedArray.forEach((group, index, arr) => {
        const tr = document.createElement("tr");
        group.forEach((name) => {
            const td = document.createElement("td");
            td.innerHTML = name;
            tr.append(td);

            // //// For the last element of the entire grouped array, set the background color for entire last row.
            // if (index === arr.length - 1) {
            //     setLastTr(tr, td);
            // }
        });
        // console.log(tr.childElementCount);
        table.append(tr);
    });
    domElem.append(table);
}

function setLastTr(tr, td) {
    //// If there are insufficient td elements, the tr color will fill in all the way across.
    //// To test, add names to the uniqueNamesArray above.
    //// Also these will need to be updated if the number of columns changes.
    if (tr.childElementCount == 1) {
        td.colSpan = 4;
    }
    else if (tr.childElementCount == 2) {
        td.colSpan = 3;
    }
    else if (tr.childElementCount == 3) {
        td.colSpan = 2;
    }
    else {
        td.colSpan = 1;
    }
}

// function CreateGridTemplate(groupedArray, domElem) {
//     //// Grid is too difficult to combione responzivness with css nth-child
//     /// Prefer funciton CreateTableTemplate
//     groupedArray.forEach((arrayGroup) => {
//         console.log(arrayGroup);
//         const row = document.createElement("div");
//         row.className = "grid-container";
//         domElem.append(row);

//         arrayGroup.forEach((feature) => {
//             const attrs = feature.attributes;
//             const div = document.createElement("div");
//             div.innerHTML = attrs.st_full;
//             row.append(div);
//         });
//     });
// }